import { makeStyles } from '@mui/styles';
import { EntityAutocompletePicker } from '@backstage/plugin-catalog-react';
import { EntityCriticalityFilter } from './EntityCriticalityFilter';
import { ExtendedEntityFilters } from './types';

const useStyles = makeStyles(
  {
    input: {},
  },
  { name: 'CatalogReactEntityCriticalityPicker' },
);

export interface EntityCriticalityPickerProps {
  initialFilter?: string[];
  hidden?: boolean;
}

export const EntityCriticalityPicker = (
  props: EntityCriticalityPickerProps,
) => {
  const { initialFilter = [], hidden = false } = props;
  const classes = useStyles();

  if (hidden) {
    return null;
  }

  return (
    <EntityAutocompletePicker<ExtendedEntityFilters>
      filtersForAvailableValues={['kind', 'type']}
      showCounts
      label="Criticality"
      name="criticality"
      path="metadata.schibsted-criticality"
      Filter={EntityCriticalityFilter}
      InputProps={{ className: classes.input }}
      initialSelectedOptions={initialFilter}
    />
  );
};
